import { digger } from '@cbre/digger';
import { simpleValueValidation } from '@miq/utils';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DisplayFunctionOptions, LovValues } from '../../../../models/template.model';
import { getRegularOrColloquialVal } from '../../template-lov-attributes.const';
import { PropertyType } from '../us/us.common';

function usageAmenitiesLov(options: DisplayFunctionOptions, usageType: PropertyType): Observable<LovValues[]> {
  const { locale, reportExportViewService } = options;
  return reportExportViewService.getLovObservablesData(
    `/lookup/amenities?type=${usageType}`,
    undefined,
    locale
  ) as Observable<LovValues[]>;
}

function getSpecificationAmenities(record, options, amenitiesType, amenitiesSubtype, amenitiesNotes) {
  const subtypeLOV$ = of(amenitiesSubtype.lovValues) || of([]);
  const amenitiesLov$ = usageAmenitiesLov(options, PropertyType.Office);

  return forkJoin([amenitiesLov$, subtypeLOV$]).pipe(
    map(([amenitiesTypeLov, amenitiesSubtypeLov]: LovValues[][]) => {
      const usagePath = 'data.usages';
      const usagesData = digger(record, usagePath);
      const officeOnlyUsages = (usagesData || []).filter(
        usage => usage.ref_property_usage_type_desc === PropertyType.Office
      );

      const amenitiesArray = [];
      for (const usage of officeOnlyUsages) {
        const amenities = usage.usage_amenity;
        const mappedAmenity = amenities.map(amenity => {
          const { property_amenity_type_desc, amenity_subtype_desc, amenity_notes } = amenity;
          const mappedType = getRegularOrColloquialVal(property_amenity_type_desc, amenitiesTypeLov);
          if (!simpleValueValidation(mappedType)) {
            return null;
          }
          let subtypeNotesValue = amenity_notes || '';
          if (simpleValueValidation(amenity_subtype_desc)) {
            subtypeNotesValue = getRegularOrColloquialVal(amenity_subtype_desc, amenitiesSubtypeLov) || '';
          }

          // NOTE: the latter condition has an intentional space
          const amenityPrefix = subtypeNotesValue === '' ? subtypeNotesValue : `${subtypeNotesValue} `;
          return `${amenityPrefix}${mappedType}`;
        });
        amenitiesArray.push(...mappedAmenity.filter(amenity => simpleValueValidation(amenity)));
      }

      return Array.isArray(amenitiesArray) && amenitiesArray.length > 0 ? amenitiesArray : ['-'];
    })
  );
}

export const emeaSpecificationAmenitiesDisplayFunctions = {
  425: {
    // 425 - Specification Amenities (Poland & Finland)
    displayFn: getSpecificationAmenities,
  },
  435: {
    // 435 - Specification Amenities (Italy)
    displayFn: getSpecificationAmenities,
  },
  512: {
    // 512 - Specification Amenities (Norway)
    displayFn: getSpecificationAmenities,
  },
  522: {
    // 522 - Specification Amenities (Norway)
    displayFn: getSpecificationAmenities,
  },
  502: {
    // 502 - Specification Amenities (Sweden)
    displayFn: getSpecificationAmenities,
  },
};
